// src/firebaseConfig.js
import { initializeApp, getApps } from "firebase/app";
import { getAnalytics, isSupported as analyticsSupported } from "firebase/analytics";
import { initializeFirestore } from "firebase/firestore";
import { getAuth, signInAnonymously } from "firebase/auth";
import { getStorage } from "firebase/storage";
import { getFunctions } from "firebase/functions";

export const firebaseConfig = {
    apiKey: "AIzaSyD_6bFrN68usqldszvpmA8omir_uBzUOLs",
    authDomain: "muulti--space.firebaseapp.com",
    projectId: "muulti--space",
    storageBucket: "muulti--space.firebasestorage.app",
    messagingSenderId: "234077676064",
    appId: "1:234077676064:web:9b31f38007b0bba9cd1245"
};

// Single app instance
export const app = getApps().length ? getApps()[0] : initializeApp(firebaseConfig);

// Optional: only init Analytics when supported (avoids dev errors)
analyticsSupported().then((ok) => { if (ok) getAnalytics(app); });

// Firestore: stabilize transport in dev / behind proxies / with extensions
export const db = initializeFirestore(app, {
    experimentalForceLongPolling: true,
    useFetchStreams: false,
});

export const auth = getAuth(app);
export const storage = getStorage(app);
export const functions = getFunctions(app);

export const anonymousAuthReady = (async () => {
    try {
        if (typeof auth.authStateReady === "function") {
            await auth.authStateReady();
        }

        if (auth.currentUser) {
            return auth.currentUser;
        }

        const credential = await signInAnonymously(auth);
        // console.log("Signed in anonymously:", credential.user?.uid);
        return credential.user;
    } catch (err) {
        console.error("Anonymous sign-in failed:", err);
        return auth.currentUser || null;
    }
})();
